/**
 * DryStep (ydm) PLP shop-mode tabs.
 *
 * Splits the collection grid into "Mix & match" (single socks) and "Ready-made packs" (pack SKUs)
 * over the SAME grid — no duplicate collection. Filtering is done by CSS keyed off attributes on the
 * <html> element (documentElement), NOT the grid: Horizon's results-list re-renders the grid section
 * on every filter / sort / infinite-scroll load, which would strip state stored on the grid. Because
 * the state lives on <html> and each server-rendered card carries `data-ydm-kind`, freshly re-rendered
 * cards stay filtered automatically with no re-apply. No-JS visitors keep the full grid. Deep-linkable
 * via ?mode= and instrumented (plp_mode_switched) for the tracking task.
 */
(function () {
  var MODES = ['mix', 'packs'];
  var root = document.documentElement;
  // Matches the section's own mobile breakpoint (styles switch at 750px).
  var MOBILE_MQ = '(max-width: 749px)';

  function hasGrid() {
    return !!document.querySelector('results-list');
  }

  class YdmPlpControls extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-ydm-mode-btn]'));
      this.equiv = this.querySelector('[data-ydm-equiv]');
      // Each mode carries a full line and an optional short line for narrow screens; short falls
      // back to full when the setting is blank. The trim is re-applied on breakpoint change so a
      // mode-switch round-trip can never leave the long line stranded on mobile.
      this.equivCopy = {
        mix: {
          full: this.getAttribute('data-equiv-mix') || '',
          short: this.getAttribute('data-equiv-mix-short') || '',
        },
        packs: {
          full: this.getAttribute('data-equiv-packs') || '',
          short: this.getAttribute('data-equiv-packs-short') || '',
        },
      };
      this.currentMode = 'mix';

      if (!this.buttons.length || !hasGrid()) return;

      // Filtering is enabled on <html>; grid re-renders can't strip it, so no-JS still shows everything.
      root.classList.add('ydm-modes-active');

      this.buttons.forEach(
        function (btn) {
          btn.addEventListener('click', function () {
            this.setMode(btn.getAttribute('data-ydm-mode-btn'), true);
          }.bind(this));
        }.bind(this)
      );

      try {
        this.mobileMql = window.matchMedia(MOBILE_MQ);
        this.mobileMql.addEventListener('change', this.applyEquiv.bind(this));
      } catch (e) {
        this.mobileMql = null;
      }

      this.setMode(this.initialMode(), false);
    }

    applyEquiv() {
      if (!this.equiv) return;
      var copy = this.equivCopy[this.currentMode];
      if (!copy) return;
      var isMobile = this.mobileMql ? this.mobileMql.matches : false;
      var text = isMobile && copy.short ? copy.short : copy.full;
      if (text) this.equiv.textContent = text;
    }

    initialMode() {
      var fromUrl;
      try {
        fromUrl = new URLSearchParams(window.location.search).get('mode');
      } catch (e) {
        fromUrl = null;
      }
      if (MODES.indexOf(fromUrl) !== -1) return fromUrl;
      var def = this.getAttribute('data-default-mode');
      return MODES.indexOf(def) !== -1 ? def : 'mix';
    }

    setMode(mode, fromUser) {
      if (MODES.indexOf(mode) === -1) mode = 'mix';
      this.currentMode = mode;
      root.setAttribute('data-ydm-mode', mode);

      this.buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-ydm-mode-btn') === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.applyEquiv();

      this.syncUrl(mode);

      if (fromUser) this.track(mode);
    }

    syncUrl(mode) {
      try {
        var url = new URL(window.location.href);
        if (mode === 'mix') {
          url.searchParams.delete('mode');
        } else {
          url.searchParams.set('mode', mode);
        }
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* no-op */
      }
    }

    track(mode) {
      var handle = (window.Shopify && Shopify.routes && Shopify.routes.root) || window.location.pathname;
      var detail = { mode: mode, collection: handle };
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'plp_mode_switched' }, detail));
      } catch (e) {
        /* no-op */
      }
      document.dispatchEvent(new CustomEvent('ydm:plp_mode_switched', { detail: detail }));
    }
  }

  if (!customElements.get('ydm-plp-controls')) {
    customElements.define('ydm-plp-controls', YdmPlpControls);
  }
})();
